import React from "react";
import { ShieldCheck, ShieldAlert } from "lucide-react";
import { useI18n } from "@/lib/i18n";

const stamp = (iso) => {
  if (!iso) return "—";
  const d = new Date(iso);
  return d.toLocaleString(undefined, {
    day: "2-digit", month: "short", hour: "2-digit", minute: "2-digit",
  });
};

/** Last few login events across the platform — a small, capped read for spotting odd access. */
export const RecentLogins = ({ events }) => {
  const { t } = useI18n();

  return (
    <div className="border border-[#2A2A2A] bg-[#0F0F0F] p-5 sm:p-7 overflow-hidden" data-testid="recent-logins">
      <p className="eyebrow mb-4">{t("recent_logins")}</p>
      <p className="text-[11px] text-[#707070] mb-5">{t("recent_logins_hint")}</p>
      {events.length === 0 ? (
        <p className="text-sm text-[#5A5A5A]" data-testid="recent-logins-empty">{t("recent_logins_empty")}</p>
      ) : (
        <div className="divide-y divide-[#1E1E1E]">
          {events.map((e, i) => (
            <div key={`${e.email}-${e.created_at}-${i}`} data-testid={`login-row-${i}`}
              className="flex flex-wrap items-start justify-between gap-3 py-3">
              <div className="min-w-0">
                <p className="text-sm truncate flex items-center gap-2">
                  {e.success
                    ? <ShieldCheck size={13} className="text-[#D4AF37] shrink-0" />
                    : <ShieldAlert size={13} className="text-[#8B0000] shrink-0" />}
                  {e.email}
                </p>
                <p className="text-[11px] text-[#707070] truncate">
                  {e.studio_name || "—"} · {e.role || "—"} · {e.method} · {e.ip}
                </p>
              </div>
              <span className="text-right shrink-0">
                <span className="font-mono-accent text-[10px] tracking-[0.18em] uppercase text-[#A8A8A8] block">
                  {stamp(e.created_at)}
                </span>
                {!e.success && (
                  <span data-testid={`login-failed-${i}`}
                    className="font-mono-accent text-[10px] tracking-[0.18em] uppercase text-[#8B0000]">
                    {t("login_failed")}
                  </span>
                )}
              </span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};
